import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'bd-ai-toolbar',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './ai-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiToolbarComponent {
  feedbackState = input<'up' | 'down' | undefined>(undefined);

  thumbsUp = output<void>();
  thumbsDown = output<void>();

  onThumbsUp(): void {
    this.thumbsUp.emit();
  }

  onThumbsDown(): void {
    this.thumbsDown.emit();
  }
}
